var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatOutlinedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xmlns: "http://www.w3.org/2000/svg",
  className: "MuiSvgIcon-root menu-button_color",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h8v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z",
  fill: "#FFFFFF"
})));
export { SvgChatOutlinedIcon as ReactComponent };
export default __webpack_public_path__ + "56b42b071c4ce1c218f53e4301017611.svg";